module.exports = __webpack_public_path__ + "img/av069.fcf43b3e.png";